import { AppFormItem, AppFormItemProps, AppRadioButton, AppRadioGroup } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { settingsTexts } from 'consts/text';

type MealPaymentTypePickerElementProps = AppFormItemProps & {
    disabled?: boolean;
};

const items: { label: string; value: string }[] = [
    {
        label: settingsTexts.settlements.meals.formLabels.previousDay,
        value: 'PREVIOUS_DAY',
    },
    {
        label: settingsTexts.settlements.meals.formLabels.currentDay,
        value: 'CURRENT_DAY',
    },
];

export const MealAbsenceReportTypePickerElement = ({
    disabled,
    ...props
}: MealPaymentTypePickerElementProps) => {
    const radioElements = items.map(({ value, label }) => (
        <AppRadioButton key={value} value={value}>
            {label}
        </AppRadioButton>
    ));

    return (
        <AppFormItem
            label={settingsTexts.settlements.meals.formLabels.absenceReport}
            name={formFields.absenceReportType}
            disabled={disabled}
            {...props}
        >
            <AppRadioGroup disabled={disabled}>{radioElements}</AppRadioGroup>
        </AppFormItem>
    );
};
